/**
 * Stores API client (Faza 12 backend)
 */

import type {
  ApiSuccess,
  CreateStoreInput,
  StoreDto,
  StoreQueryInput,
  TenantSettingsDto,
  UpdateStoreInput,
  UpdateTenantSettingsInput,
} from '@avtofix/shared';

import { apiClient } from '@/shared/lib/api-client';

export const storesApi = {
  list: async (query: Partial<StoreQueryInput> = {}): Promise<ApiSuccess<StoreDto[]>> => {
    return apiClient.getPaginated<StoreDto>('/stores', { params: query });
  },
  getOne: async (id: string): Promise<StoreDto> => {
    return apiClient.get<StoreDto>(`/stores/${id}`);
  },
  create: async (input: CreateStoreInput): Promise<StoreDto> => {
    return apiClient.post<StoreDto>('/stores', input);
  },
  update: async (id: string, input: UpdateStoreInput): Promise<StoreDto> => {
    return apiClient.patch<StoreDto>(`/stores/${id}`, input);
  },
  updateSettings: async (
    id: string,
    input: UpdateTenantSettingsInput,
  ): Promise<TenantSettingsDto> => {
    return apiClient.patch<TenantSettingsDto>(`/stores/${id}/settings`, input);
  },
  delete: async (id: string): Promise<{ id: string }> => {
    return apiClient.delete<{ id: string }>(`/stores/${id}`);
  },

  // Marketplace approval flow
  marketplaceRequest: async (id: string): Promise<StoreDto> => {
    return apiClient.post<StoreDto>(`/stores/${id}/marketplace-request`);
  },
  marketplaceApprove: async (id: string): Promise<StoreDto> => {
    return apiClient.post<StoreDto>(`/stores/${id}/marketplace-approve`);
  },
  marketplaceReject: async (id: string, reason?: string): Promise<StoreDto> => {
    return apiClient.post<StoreDto>(`/stores/${id}/marketplace-reject`, { reason });
  },
  marketplaceRequests: async (): Promise<StoreDto[]> => {
    return apiClient.get<StoreDto[]>('/stores/marketplace/requests');
  },
};
